const loading = (element, start = true) => {
  if (start) {
    element.classList.add("loading");
  } else {
    element.classList.remove("loading");
  }
};
export default loading;